export const COMPANY = {
  name: "Ferrer Auto Transport",
  phone: "908-967-1764",
  phoneRaw: "+19089671764",
  fax: "732-694-6656",
  email: "fatlle@hotmail.com",
  address: "Woodbridge, New Jersey 07095",
  cityState: "Woodbridge, NJ",
};

export const US_STATES = [
  "AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA",
  "KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ",
  "NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT",
  "VA","WA","WV","WI","WY","DC"
];

export const VEHICLE_TYPES = [
  "Sedan",
  "SUV",
  "Pickup Truck",
  "Luxury / Sports Car",
  "Classic / Vintage",
  "Motorcycle",
  "Van / Minivan",
  "Heavy Duty",
  "Other",
];

export const SERVICES = [
  {
    title: "Open Carrier Transport",
    desc: "Cost-effective standard shipping on industry-grade carriers — the most popular and reliable way to move daily-driver vehicles nationwide.",
    image: "https://images.pexels.com/photos/34539243/pexels-photo-34539243.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Enclosed Luxury Vehicle Shipping",
    desc: "White-glove protection for exotics, classics and high-value automobiles. Climate-controlled, fully enclosed, and handled by elite operators.",
    image: "https://images.unsplash.com/photo-1775629620472-9e17d06bb6e6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBjYXIlMjBoaWdod2F5fGVufDB8fHx8MTc3NzIxNTM5NHww&ixlib=rb-4.1.0&q=85",
  },
  {
    title: "Dealer & Fleet Transport",
    desc: "Multi-unit logistics for dealerships and fleet managers. Predictable scheduling, transparent reporting, and volume pricing built for partners.",
    image: "https://images.pexels.com/photos/9702373/pexels-photo-9702373.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Auction Vehicle Shipping",
    desc: "Fast pickup from Manheim, Copart, IAA and dealer auctions across the country. We coordinate paperwork, gate releases, and delivery end-to-end.",
    image: "https://images.pexels.com/photos/10481108/pexels-photo-10481108.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Cross-Country Auto Transport",
    desc: "Coast-to-coast shipping with real-time updates. From New Jersey to California, Texas, Florida and every corridor in between.",
    image: "https://images.pexels.com/photos/19829080/pexels-photo-19829080.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    title: "Seasonal Snowbird Transport",
    desc: "Northeast to Florida and back — purpose-built schedules for snowbirds. Reliable seasonal pricing, priority pickup, and on-time delivery.",
    image: "https://images.pexels.com/photos/11053643/pexels-photo-11053643.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const TRUST_INDICATORS = [
  { title: "Licensed & Insured", desc: "Full federal authority, cargo insurance on every vehicle." },
  { title: "Fast Response", desc: "Quotes returned within the hour, not the next day." },
  { title: "Door-to-Door", desc: "Pickup and delivery anywhere it is legally accessible." },
  { title: "Competitive Pricing", desc: "Honest, transparent rates — no hidden fees, ever." },
  { title: "Nationwide Coverage", desc: "All 48 contiguous states, with NJ as our home base." },
];

export const FAQS = [
  {
    q: "How long does auto transport take?",
    a: "Most domestic moves take 2–9 days depending on distance and route. East Coast to West Coast typically runs 7–9 days; regional moves under 1,000 miles often complete in 2–4 days. We give realistic windows and keep you informed throughout.",
  },
  {
    q: "Is my vehicle insured during transport?",
    a: "Yes. Every load is covered by federally required cargo insurance, and we carry additional coverage for high-value vehicles. We share certificates on request before any vehicle is loaded.",
  },
  {
    q: "How much does it cost to ship a car?",
    a: "Pricing depends on distance, vehicle size, transport type (open vs. enclosed), and seasonal demand. Submit a quote and we will return real, locked pricing — not generic estimates.",
  },
  {
    q: "Do I need to be present for pickup and delivery?",
    a: "You or a designated representative (18+) must be present at both pickup and delivery to inspect the vehicle and sign the bill of lading. We coordinate timing carefully.",
  },
  {
    q: "Open vs. enclosed transport — which should I choose?",
    a: "Open carriers are the standard for daily drivers and most SUVs — safe, efficient, and cost-effective. Enclosed transport is recommended for exotic, luxury, classic, or low-clearance vehicles where added protection is essential.",
  },
  {
    q: "Can I pack personal items in the car?",
    a: "Carriers generally allow up to 100 lbs of personal items in the trunk, but they are not insured. We recommend keeping the vehicle empty for fastest, safest transport.",
  },
];
